import { TestPlanScreeningType } from '@/app/components/testing-plan/components/your-testing-plan/types';
import { TypeOfCancer } from '@/components/icons/icon-catch/types';
import { CancerTypeRisk } from '@/repositories/risk.repository';

type RisksSortValueType = Record<TypeOfCancer, number>;

export function sortTestingRecommendations(risks: CancerTypeRisk[], testingPlan: TestPlanScreeningType[] = []) {
  const risksSortValue = risks.reduce<RisksSortValueType>((acc, { cancer }, i) => {
    acc[cancer] = risks.length - i;

    return acc;
  }, {} as RisksSortValueType);

  testingPlan.sort((a, b) => {
    return (risksSortValue[b.icon as TypeOfCancer] ?? 0) - (risksSortValue[a.icon as TypeOfCancer] ?? 0);
  });

  return testingPlan;
}
